import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import styles from './Search.module.css';

type SearchProps = {
  onSubmit: (input: string) => void;
}

function Search(props: SearchProps) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState('');
  const [error, setError] = useState();

  const handleChange = (event: any) => {
    setInputValue(event.target.value);
  };

  const submitHandler = (event: any) => {
    event.preventDefault();
    if (inputValue.length < 3) {
      setError(t('header.search.notEnoughSymbols'));
    } else {
      setError(undefined);
      props.onSubmit(inputValue.toLowerCase());
      setInputValue('');
    }
  };

  return (
    <div className={styles.container}>
      <form className={styles.form} onSubmit={submitHandler}>
        <input
          className={styles.input}
          type='search'
          placeholder={t('header.search.placeholder')}
          value={inputValue}
          onChange={handleChange}
        />
        <button className={styles.button} type='submit'>Search</button>
      </form>
      {error && <p className={styles.errorMessage}>{error}</p>}
    </div>
  );
}

export default Search;
